export default {
    empty: 'Предписания отсутствуют',
    tableEmpty: 'Таблица пуста',
};
